import React from "react";
import "./EditTemplateDialog.css";
import { withTranslation } from "react-i18next";
import { Accordion, Button, Card, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";
import Switch from "react-switch";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import TagSelection from "../../../../components/tagSelection/TagSelection";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

class EditTemplateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        initValid: true,
        rule: ValidationHelper.isNonEmptyString
      },
      description: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: true,
        rule: ValidationHelper.isExtendedDescription
      },
      isPublished: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      hasInternalLogin: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      preferredNetworkProfile: {
        defaultValue: null,
        initValid: true,
        rule: ValidationHelper.isOptionalID
      },
      softwareCatalogs: {
        defaultValue: [],
        initValid: true,
        rule: ValidationHelper.isSoftwareCatalogsArray
      },
      tags: {
        defaultValue: [],
        initValid: true,
        rule: ValidationHelper.isStringArray
      },
      type: {
        defaultValue: 0,
        initValid: true,
        rule: ValidationHelper.isInt
      }
    };

    this.state = {
      apiError: "",
      dialogApiError: "",
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  getPlaceholderConfiguration() {
    return "";
  }

  handleChange(event) {
    this.setState({
      validation: Object.assign(
        {},
        ValidationHelper.update(event, this.state.validation)
      )
    });
  }

  refreshValidation() {
    const validationDefinition = {
      name: {
        defaultValue: (" " + this.props.instanceTemplate?.name).substr(1) || "",
        initValid: true,
        rule: ValidationHelper.isNonEmptyString
      },
      description: {
        defaultValue:
          Object.assign({}, this.props.instanceTemplate?.description) ||
          ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: true,
        rule: ValidationHelper.isNonEmptyExtendedDescription
      },
      isPublished: {
        defaultValue: this.props.instanceTemplate?.isPublished
          ? true
          : false || false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      hasInternalLogin: {
        defaultValue: this.props.instanceTemplate?.hasInternalLogin
            ? true
            : false || false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      preferredNetworkProfile: {
        defaultValue: this.props.instanceTemplate.preferredNetworkProfile,
        initValid: true,
        rule: ValidationHelper.isOptionalID
      },
      softwareCatalogs: {
        defaultValue: [...this.props.associatedSoftwareCatalogs],
        initValid: true,
        rule: ValidationHelper.isSoftwareCatalogsArray
      },
      tags: {
        defaultValue: [...this.props.instanceTemplate.tags],
        initValid: true,
        rule: ValidationHelper.isStringArray
      },
      type: {
        defaultValue: this.props.instanceTemplate.type,
        initValid: true,
        rule: ValidationHelper.isInt
      }
    };
    this.setState({
      validation: ValidationHelper.getValidation(
        this.props.instanceTemplate
          ? validationDefinition
          : this.validationDefinition
      )
    });
  }

  componentDidMount() {
    this.refreshValidation();
  }

  async onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      await this.props.onSubmit(
        Object.assign(validatedData, {
          configuration: this.props.instanceTemplate.configuration
        })
      );
      this.refreshValidation();
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  render() {
    const { t, i18n } = this.props;
    const templateTypes = [
      {
        name: t(
          "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.TypeLabels.VirtualComputer"
        ),
        value: 0
      },
      {
        name: t(
          "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.TypeLabels.Browser"
        ),
        value: 1
      },
      {
        name: t(
            "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.TypeLabels.Local"
        ),
        value: 2
      }
    ];

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        title={t("SingleInstanceTemplate.InstanceTemplateEditDialog.Title")}
        dialogApiError={this.props.dialogApiError}
        rightButtonCallback={this.onSubmit}
        rightButtonText={t("SingleInstanceTemplate.InstanceTemplateEditDialog.Form.Submit")}
        rightButtonIsLoading={this.props.isSaving}
        leftButtonText={t("DialogCancel")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid ||
          !ValidationHelper.hasChanged(this.state.validation) ||
          this.props.instanceTemplate?.isLocked ||
          this.props.isSaving}
        body={(<Form onSubmit={this.onSubmit}>
          <Accordion defaultActiveKey="0">
            <Card className="accordion-top-card">
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="0"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.name.isValid &&
                      this.state.validation.isPublished
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>
                        {t(
                          "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.ToggleBasic"
                        )}
                      </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form.Group controlId="formInstanceTemplateName">
                    <Form.Label>
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.InstanceTemplateName"
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder={t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.InstanceTemplateNamePlaceholder"
                      )}
                      value={this.state.validation.name.value}
                      isInvalid={!this.state.validation.name.isValid}
                      onChange={this.handleChange}
                      disabled={this.props.instanceTemplate?.isLocked}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.ValidationError.Name"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchIsPublished">
                    <Switch
                      className="isPublishedSwitch"
                      onColor="#54BF8D"
                      checked={this.state.validation.isPublished.value}
                      onChange={state => {
                        this.handleChange({
                          target: {
                            name: "isPublished",
                            value: state
                          }
                        });
                      }}
                      height={18}
                      width={40}
                      disabled={this.props.instanceTemplate?.isLocked}
                    />
                    <Form.Label>
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.IsPublished"
                      )}
                    </Form.Label>
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.isPublished.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.ValidationError.IsPublished"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchHasInternalLogin">
                    <Switch
                        className="isPublishedSwitch"
                        onColor="#54BF8D"
                        checked={this.state.validation.hasInternalLogin.value}
                        onChange={state => {
                          this.handleChange({
                            target: {
                              name: "hasInternalLogin",
                              value: state
                            }
                          });
                        }}
                        height={18}
                        width={40}
                    />
                    <Form.Label>
                      {t(
                          "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.HasInternalLogin"
                      )}
                    </Form.Label>
                    <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.hasInternalLogin.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                          "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.ValidationError.HasInternalLogin"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSelectType">
                    <Form.Label>
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.Type"
                      )}
                    </Form.Label>
                    <BaseSelect
                      options={templateTypes}
                      onChange={s => {
                        this.handleChange({
                          target: {
                            name: "type",
                            value: s.value
                          }
                        });
                      }}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option.value}
                      value={
                        templateTypes[this.state.validation.type.value]
                      }
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.type.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "PreferredNetworkProfilePlaceholder.InstanceTemplateEditDialog.Form.ValidationError.Type"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSelectPreferredNetworkProfile">
                    <Form.Label>
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.PreferredNetworkProfile"
                      )}
                    </Form.Label>
                    <BaseSelect
                      options={this.props.networkProfiles}
                      onChange={s => {
                        this.handleChange({
                          target: {
                            name: "preferredNetworkProfile",
                            value: s ? s._id : null
                          }
                        });
                      }}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option._id}
                      escapeClearsValue={true}
                      isClearable={true}
                      clearValue={null}
                      placeholder={t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.PreferredNetworkProfilePlaceholder"
                      )}
                      backspaceRemovesValue={true}
                      value={this.props.networkProfiles
                        .filter(
                          o =>
                            o._id ===
                            this.state.validation.preferredNetworkProfile
                              .value
                        )
                        .shift()}
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={
                        !this.state.validation.preferredNetworkProfile
                          .isValid
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.ValidationError.NetworkProfile"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSelectSoftwareCatalogs">
                    <Form.Label>
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.SoftwareCatalogs"
                      )}
                    </Form.Label>
                    <BaseSelect
                      options={this.props.softwareCatalogs}
                      isMulti={true}
                      onChange={s => {
                        this.handleChange({
                          target: {
                            name: "softwareCatalogs",
                            value: s || []
                          }
                        });
                      }}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option._id}
                      placeholder={t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.SoftwareCatalogsPlaceholder"
                      )}
                      backspaceRemovesValue={true}
                      escapeClearsValue={true}
                      isClearable={true}
                      value={this.state.validation.softwareCatalogs.value}
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={
                        !this.state.validation.softwareCatalogs.isValid
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.ValidationError.SoftwareCatalogs"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSelectTags">
                    <Form.Label>
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.Tags"
                      )}
                    </Form.Label>
                    <TagSelection
                      onChange={tags => {
                        this.handleChange({
                          target: {
                            name: "tags",
                            value: tags || []
                          }
                        });
                      }}
                      max={10}
                      selectedTags={this.state.validation.tags.value}
                      value={this.state.validation.tags.value}
                      placeholder={t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.TagsPlaceholder"
                      )}
                      className="mb-3"
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.tags.isValid}
                    />
                    <small>
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.TagsHint"
                      )}
                    </small>
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.ValidationError.Tags"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          <Accordion>
            <Card className="accordion-mid-card">
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="2"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.isPublished.isValid
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>
                        {t(
                          "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.Description"
                        )}
                      </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  <Form.Group>
                    <MarkDownEditor
                      disabled={this.props.instanceTemplate?.isLocked}
                      defaultValue={this.props.instanceTemplate ?
                          this.props.instanceTemplate.description: ValidationHelper.getDefaultValueExtendedDescription()}
                      onChange={value =>
                        this.handleChange({
                          target: {
                            name: "description",
                            value: value
                          }
                        })
                      }
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.description.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleInstanceTemplate.InstanceTemplateEditDialog.Form.ValidationError.Description"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Form>)}
      />
    );
  }
}

export default withTranslation()(EditTemplateDialog);
